import { Component, OnInit } from '@angular/core';
import { User, UserContactInfo, UserNotification, UserClient, StateList, MyAccountClient, AddUser, USPSAddressValidationRequest, USPSAddressValidationResponse } from '../Services/WOWApi.Service';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';

function notificationPreferenceValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.get('isNotificationEnabled')?.value) {
    return null;
  }
  const isEmail = control.get('isEmail')?.value;
  const isPhone = control.get('isPhone')?.value;
  return isEmail || isPhone ? null : { notificationPreferenceRequired: true };
}
import { PasswordValidation } from '../Common/password-validation';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonServices } from '../Common/CommonServices';
import { CommonService } from '../Services/common.service';
import { LoginServiceService } from '../Services/login-service.service';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  standalone: false
})
export class RegisterComponent implements OnInit {
  statelist: StateList[] = [];
  userInfo: AddUser;
  form: UntypedFormGroup;
  hidePw = true;
  hideConfirmPw = true;
  isValidatingBillingAddress = false;
  isValidatingShippingAddress = false;
  billingAddressValidation: USPSAddressValidationResponse;
  shippingAddressValidation: USPSAddressValidationResponse;
  isMobileView = false;
  subscription: Subscription;
  asHost = false;

  constructor(private formBuilder: UntypedFormBuilder,
    private client: UserClient,
    private commonServices: CommonServices,
    private router: Router,
    private route: ActivatedRoute,
    private loginServiceService: LoginServiceService,
    private myAccountClient: MyAccountClient,
    private commonService: CommonService) { }

  ngOnInit(): void {
    this.userInfo = new AddUser();
    this.asHost = this.route.snapshot.queryParamMap.get('asHost') === '1';
    if (this.asHost) {
      this.loginServiceService.redirectUrl = '/SignUpHost';
    }
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.GetForm();
    this.getStateList();
    this.listenBillingChanges();
  }

  listenBillingChanges() {
    this.form.get('Address')?.valueChanges.subscribe(() => this.enableShippingIfBillingChanged());
    this.form.get('city')?.valueChanges.subscribe(() => this.enableShippingIfBillingChanged());
    this.form.get('state')?.valueChanges.subscribe(() => this.enableShippingIfBillingChanged());
    this.form.get('zipCode')?.valueChanges.subscribe(() => this.enableShippingIfBillingChanged());
  }

  enableShippingIfBillingChanged() {
    if (this.form.get('ShipingAsBilling')?.value === true) {
      this.form.get('ShipingAsBilling')?.setValue(false, { emitEvent: false });
    }

    this.form.get('ShipingStreetAddress')?.enable({ emitEvent: false });
    this.form.get('ShipingCity')?.enable({ emitEvent: false });
    this.form.get('ShipingState')?.enable({ emitEvent: false });
    this.form.get('ShipingZipCode')?.enable({ emitEvent: false });
  }

  getStateList() {
    this.myAccountClient.getStateList().subscribe(response => {
      this.statelist = response;
    });
  }

  GetForm() {
    this.form = this.formBuilder.group({
      EmailId: ['', [Validators.required, Validators.email]],
      FirstName: ['', Validators.required],
      LastName: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      password: ['', [Validators.required, Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])\\S{8,30}$')]],
      isEmail: [false],
      isPhone: [false],
      isNotificationEnabled: [false],
      confirmPassword: ['', Validators.required],
      isGetNotifiedWhenVideoGoesLive: [false],
      isAcceptTermsConditions: [false, Validators.requiredTrue],
      Address: ['', [Validators.required, Validators.minLength(5)]],
      city: ['', [Validators.required, Validators.minLength(3)]],
      state: ['', [Validators.required]],
      zipCode: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(5)]],
      ShipingAsBilling: [false],
      ShipingStreetAddress: ['', [Validators.required, Validators.minLength(5)]],
      ShipingCity: ['', [Validators.required, Validators.minLength(3)]],
      ShipingState: ['', [Validators.required]],
      ShipingZipCode: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(5)]]
    }, {
      validators: [PasswordValidation.MatchPassword, notificationPreferenceValidator]
    });
  }

  onChangeShippingAsBilling() {
    if (this.form.controls['ShipingAsBilling'].value === true) {
      this.form.controls['ShipingStreetAddress'].setValue(this.form.controls['Address'].value);
      this.form.controls['ShipingCity'].setValue(this.form.controls['city'].value);
      this.form.controls['ShipingState'].setValue(this.form.controls['state'].value);
      this.form.controls['ShipingZipCode'].setValue(this.form.controls['zipCode'].value);

      this.userInfo.shipingStreetAddress = this.form.controls['Address'].value;
      this.userInfo.shipingCity = this.form.controls['city'].value;
      this.userInfo.shipingState = this.form.controls['state'].value;
      this.userInfo.shipingZipCode = this.form.controls['zipCode'].value;

      this.form.controls['ShipingStreetAddress'].disable({ emitEvent: false });
      this.form.controls['ShipingCity'].disable({ emitEvent: false });
      this.form.controls['ShipingState'].disable({ emitEvent: false });
      this.form.controls['ShipingZipCode'].disable({ emitEvent: false });

      this.form.updateValueAndValidity();
      console.log(this.form);
    } else {
      this.form.controls['ShipingStreetAddress'].reset();
      this.form.controls['ShipingCity'].reset();
      this.form.controls['ShipingState'].reset();
      this.form.controls['ShipingZipCode'].reset();
    }
  }

  GetFormData() {
    this.userInfo.userContactInfos = [];
    this.userInfo.userNotifications = [];
    this.userInfo.userContactInfos.push(new UserContactInfo());
    this.userInfo.userNotifications.push(new UserNotification());
    this.userInfo.emailId = this.form.controls["EmailId"].value;
    this.userInfo.firstName = this.form.controls["FirstName"].value;
    this.userInfo.lastName = this.form.controls["LastName"].value;
    this.userInfo.password = this.form.controls["password"].value;
    this.userInfo.userContactInfos[0].city = this.form.controls["city"].value;
    this.userInfo.userContactInfos[0].streetAddress = this.form.controls["Address"].value;
    this.userInfo.userContactInfos[0].state = this.form.controls["state"].value;
    this.userInfo.userContactInfos[0].zipCode = this.form.controls["zipCode"].value;
    this.userInfo.userContactInfos[0].phoneNumber = this.form.controls["phoneNumber"].value;
    this.userInfo.isNotificationEnabled = this.form.controls["isNotificationEnabled"].value;
    if (this.userInfo.isNotificationEnabled) {
      this.userInfo.userNotifications[0].isEmail = this.form.controls["isEmail"].value;
      this.userInfo.userNotifications[0].isPhone = this.form.controls["isPhone"].value;
    }
    if (this.form.controls['ShipingAsBilling'].value !== true) {
      this.userInfo.shipingStreetAddress = this.form.controls['ShipingStreetAddress'].value;
      this.userInfo.shipingCity = this.form.controls['ShipingCity'].value;
      this.userInfo.shipingState = this.form.controls['ShipingState'].value;
      this.userInfo.shipingZipCode = this.form.controls['ShipingZipCode'].value;
    }
  }

  validateBillingAddress() {
    const streetAddress = this.form.controls['Address'].value;
    const city = this.form.controls['city'].value;
    const stateName = this.form.controls['state'].value;
    const state = this.statelist.find(s => s.name === stateName)?.stateCode || stateName;
    const zipCode = this.form.controls['zipCode'].value;

    if (!streetAddress || !city || !state || !zipCode) {
      this.commonServices.showMessage('error', 'Please fill in all billing address fields before validating.', 5);
      return;
    }

    this.isValidatingBillingAddress = true;
    const request = USPSAddressValidationRequest.fromJS({
      streetAddress: streetAddress,
      city: city,
      state: state,
      zipCode: zipCode
    });

    this.myAccountClient.validateAddress(request).subscribe(
      response => {
        this.isValidatingBillingAddress = false;
        this.billingAddressValidation = response;
        
        if (response.success && response.isValid) {
          // Update form with validated address
          if (response.validatedStreetAddress) {
            this.form.controls['Address'].setValue(response.validatedStreetAddress);
          }
          if (response.validatedCity) {
            this.form.controls['city'].setValue(response.validatedCity);
          }
          if (response.validatedState) {
            const validatedState = this.statelist.find(s => s.stateCode === response.validatedState || s.name === response.validatedState);
            if (validatedState) {
              this.form.controls['state'].setValue(validatedState.name);
            }
          }
          if (response.validatedZipCode) {
            this.form.controls['zipCode'].setValue(response.validatedZipCode);
          }

          this.commonServices.showMessage('success', 'Billing address validated successfully!', 3);
        } else {
          this.commonServices.showMessage('warning', this.commonServices.friendlyAddressValidationMessage(response.errorMessage, response), 5);
        }
      },
      error => {
        this.isValidatingBillingAddress = false;
        this.commonServices.showMessage('error', 'Error validating address. Please try again.', 5);
      }
    );
  }

  validateShippingAddress() {
    const streetAddress = this.form.controls['ShipingStreetAddress'].value;
    const city = this.form.controls['ShipingCity'].value;
    const stateName = this.form.controls['ShipingState'].value;
    const state = this.statelist.find(s => s.name === stateName)?.stateCode || stateName;
    const zipCode = this.form.controls['ShipingZipCode'].value;

    if (!streetAddress || !city || !state || !zipCode) {
      this.commonServices.showMessage('error', 'Please fill in all shipping address fields before validating.', 5);
      return;
    }

    this.isValidatingShippingAddress = true;
    const request = USPSAddressValidationRequest.fromJS({
      streetAddress: streetAddress,
      city: city,
      state: state,
      zipCode: zipCode
    });

    this.myAccountClient.validateAddress(request).subscribe(
      response => {
        this.isValidatingShippingAddress = false;
        this.shippingAddressValidation = response;
        
        if (response.success && response.isValid) {
          // Update form with validated address
          if (response.validatedStreetAddress) {
            this.form.controls['ShipingStreetAddress'].setValue(response.validatedStreetAddress);
          }
          if (response.validatedCity) {
            this.form.controls['ShipingCity'].setValue(response.validatedCity);
          }
          if (response.validatedState) {
            const validatedState = this.statelist.find(s => s.stateCode === response.validatedState || s.name === response.validatedState);
            if (validatedState) {
              this.form.controls['ShipingState'].setValue(validatedState.name);
            }
          }
          if (response.validatedZipCode) {
            this.form.controls['ShipingZipCode'].setValue(response.validatedZipCode);
          }

          this.commonServices.showMessage('success', 'Shipping address validated successfully!', 3);
        } else {
          this.commonServices.showMessage('warning', this.commonServices.friendlyAddressValidationMessage(response.errorMessage, response), 5);
        }
      },
      error => {
        this.isValidatingShippingAddress = false;
        this.commonServices.showMessage('error', 'Error validating address. Please try again.', 5);
      }
    );
  }

  RegisterUser() {
    this.form.markAllAsTouched();
    if (!this.form.controls.phoneNumber.valid) {
      this.commonServices.showMessage('error', 'Mobile Number length must be 10 digits', 5);
      return;
    }
    if (!this.form.controls.EmailId.valid) {
      this.commonServices.showMessage('error', 'Please provide valid email address', 5);
      return;
    }
    if (!this.form.controls.isAcceptTermsConditions.value) {
      this.commonServices.showMessage('error', 'Please accept terms & conditions to proceed.', 5);
      return;
    }
    if (!this.form.controls.password.valid) {
      this.commonServices.showMessage('error', 'Please provide valid password', 5);
      return;
    }
    if (this.form.controls.isNotificationEnabled.value && !this.form.controls.isEmail.value && !this.form.controls.isPhone.value) {
      this.commonServices.showMessage('error', 'Please select at least one notification preference (Email or Phone)', 5);
      return;
    }
    // if (!this.form.valid) {
    //   this.commonServices.showMessage('error', `Please check & rectify the error to proceed.`, 5);
    //   return;
    // }
    console.log(this.form.value)
    var errors: any = this.getFormValidationErrors();
    if (errors.length > 0)
      this.commonServices.showMessage('error', `${errors}`, 10);
    
    this.GetFormData();
    this.client.createUser(this.userInfo).subscribe(
      response => {
        if (response === null) {
          this.commonServices.showMessage('error', `Email Id '${this.userInfo.emailId}' is already registered, please re-check your Email Id.`, 6, 'top');
        } else {
          this.commonServices.showMessage('success', `User Create Sucessfully.`, 3, 'top');
          this.router.navigate(["/login"]);
        }
      }
    );
  }

  onChangeNotificationEnabled(event) {
    if (!event.checked) {
      this.form.controls['isEmail'].setValue(false);
      this.form.controls['isPhone'].setValue(false);
    }
    this.form.updateValueAndValidity();
  }

  onNotificationPreferenceChange() {
    this.form.updateValueAndValidity();
  }

  getFormValidationErrors(): string {

    const messages: string[] = [];

    const fieldNames: any = {
      EmailId: 'Email Address',
      FirstName: 'First Name',
      LastName: 'Last Name',
      phoneNumber: 'Phone Number',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      Address: 'Billing Address',
      city: 'Billing City',
      state: 'Billing State',
      zipCode: 'Billing Zip Code',
      ShipingStreetAddress: 'Shipping Address',
      ShipingCity: 'Shipping City',
      ShipingState: 'Shipping State',
      ShipingZipCode: 'Shipping Zip Code',
      isAcceptTermsConditions: 'Terms & Conditions'
    };

    Object.keys(this.form.controls).forEach((key: string) => {

      const control = this.form.get(key);

      if (!control || !control.errors) {
        return;
      }

      const errors = control.errors;

      const fieldName = fieldNames[key] || key;

      // Required
      if (errors['required']) {
        messages.push(`${fieldName} is required`);
      }

      // Required True
      if (errors['requiredTrue']) {
        messages.push(`${fieldName} must be accepted`);
      }

      // Email
      if (errors['email']) {
        messages.push(`${fieldName} is not a valid email address`);
      }

      // Min Length
      if (errors['minlength']) {
        messages.push(
          `${fieldName} must be at least ${errors['minlength'].requiredLength} characters`
        );
      }

      // Max Length
      if (errors['maxlength']) {
        messages.push(
          `${fieldName} cannot exceed ${errors['maxlength'].requiredLength} characters`
        );
      }

      // Pattern
      if (errors['pattern']) {

        if (key === 'password') {

          messages.push(
            'Password must contain uppercase, lowercase, number, special character and be 8-30 characters long'
          );

        }
        else if (key === 'phoneNumber') {

          messages.push(
            'Phone Number format is invalid'
          );

        }
        else {

          messages.push(
            `${fieldName} format is invalid`
          );
        }
      }
    });

    // Password Match Validation
    if (
      this.form.errors &&
      (
        this.form.errors['MatchPassword'] ||
        this.form.errors['passwordMismatch']
      )
    ) {
      messages.push(
        'Password and Confirm Password do not match'
      );
    }

    // Remove duplicate messages
    const uniqueMessages = [...new Set(messages)];

    return uniqueMessages.join(', ');
  }
}
